"use client";
import Image from "next/image";
import { ASSET_PREFIX } from "@/config";
import Link from "next/link";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

const ContactPopup = dynamic(() => import("./ContactPopup"), {
  ssr: false,
});

export default function Footer() {
  const Location = usePathname();
  const [loadPopup, setLoadPopup] = useState(false);

  useEffect(() => {
    const load = () => setLoadPopup(true);

    window.addEventListener("pointerdown", load, { once: true, passive: true });
    window.addEventListener("keydown", load, { once: true });
    window.addEventListener("scroll", load, { once: true, passive: true });

    const timer = window.setTimeout(load, 3500);

    return () => {
      window.removeEventListener("pointerdown", load);
      window.removeEventListener("keydown", load);
      window.removeEventListener("scroll", load);
      window.clearTimeout(timer);
    };
  }, []);
  const links = [
    {
      href: "https://www.linkedin.com/company/pluswilla/?viewAsMember=true",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="https://www.w3.org/2000/svg">
          <path
            d="M0 2.19284C0 0.981612 1.00649 0 2.24833 0H28.3672C29.6091 0 30.6156 0.981612 30.6156 2.19284V28.4227C30.6156 29.634 29.6091 30.6156 28.3672 30.6156H2.24833C1.00649 30.6156 0 29.634 0 28.4227V2.19284ZM9.45829 25.6291V11.8042H4.86405V25.6291H9.45829ZM7.16213 9.91562C8.76371 9.91562 9.76062 8.85555 9.76062 7.5276C9.73192 6.17095 8.76562 5.13959 7.19274 5.13959C5.61987 5.13959 4.59234 6.17286 4.59234 7.5276C4.59234 8.85555 5.58925 9.91562 7.13151 9.91562H7.16213ZM16.5535 25.6291V17.9082C16.5535 17.4949 16.5841 17.0816 16.7065 16.7869C17.0376 15.9622 17.7934 15.1069 19.0639 15.1069C20.7267 15.1069 21.3907 16.3736 21.3907 18.2335V25.6291H25.985V17.6996C25.985 13.4517 23.7194 11.477 20.6961 11.477C18.2584 11.477 17.1658 12.8164 16.5535 13.7598V13.8076H16.5228L16.5535 13.7598V11.8042H11.9611C12.0185 13.1015 11.9611 25.6291 11.9611 25.6291H16.5535Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      href: "https://www.facebook.com/pluswilla",
      icon: (
        <svg
          width="25"
          height="24"
          viewBox="0 0 32 31"
          fill="none"
          xmlns="https://www.w3.org/2000/svg">
          <path
            d="M31.443 15.4015C31.443 6.89529 24.4046 0 15.7235 0C7.03842 0.00191323 0 6.8953 0 15.4034C0 23.0889 5.74942 29.46 13.2634 30.6156V19.8536H9.27453V15.4034H13.2673V12.0075C13.2673 8.14846 15.6154 6.01712 19.2054 6.01712C20.9266 6.01712 22.7246 6.3175 22.7246 6.3175V10.1057H20.7419C18.7907 10.1057 18.1816 11.2938 18.1816 12.5125V15.4015H22.5399L21.8443 19.8517H18.1797V30.6137C25.6936 29.4581 31.443 23.087 31.443 15.4015Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      href: "https://www.instagram.com/plus.willa/",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="https://www.w3.org/2000/svg"
          className="fill-current text-white hover:text-[#b08d38] transition-colors duration-300">
          <path
            d="M15.3078 0C11.1536 0 10.6313 0.0191347 8.99906 0.0918467C7.36687 0.168386 6.25514 0.424791 5.28118 0.803658C4.25909 1.18698 3.33354 1.78986 2.56979 2.56979C1.78986 3.33354 1.18698 4.25909 0.803658 5.28118C0.424791 6.25323 0.166472 7.36687 0.0918467 8.99332C0.0191347 10.6293 0 11.1498 0 15.3097C0 19.4658 0.0191347 19.9862 0.0918467 21.6184C0.168386 23.2487 0.424791 24.3604 0.803658 25.3344C1.19592 26.3409 1.7183 27.1943 2.56979 28.0458C3.41938 28.8973 4.27279 29.4216 5.27927 29.8119C6.25514 30.1908 7.36496 30.4491 8.99524 30.5237C10.6293 30.5964 11.1498 30.6156 15.3078 30.6156C19.4658 30.6156 19.9843 30.5964 21.6184 30.5237C23.2468 30.4472 24.3623 30.1908 25.3363 29.8119C26.3577 29.4283 27.2826 28.8255 28.0458 28.0458C28.8973 27.1943 29.4196 26.3409 29.8119 25.3344C30.1889 24.3604 30.4472 23.2487 30.5237 21.6184C30.5964 19.9862 30.6156 19.4658 30.6156 15.3078C30.6156 11.1498 30.5964 10.6293 30.5237 8.99524C30.4472 7.36687 30.1889 6.25323 29.8119 5.28118C29.4286 4.25909 28.8257 3.33354 28.0458 2.56979C27.282 1.78986 26.3565 1.18698 25.3344 0.803658C24.3585 0.424791 23.2449 0.166472 21.6165 0.0918467C19.9824 0.0191347 19.4638 0 15.304 0H15.3078ZM13.9358 2.75923H15.3097C19.3969 2.75923 19.881 2.77262 21.494 2.84725C22.9865 2.91422 23.7979 3.16488 24.3375 3.37345C25.0512 3.65091 25.5621 3.98385 26.0979 4.51962C26.6336 5.0554 26.9647 5.56438 27.2421 6.28002C27.4526 6.8177 27.7013 7.62902 27.7683 9.12153C27.8429 10.7346 27.8582 11.2187 27.8582 15.304C27.8582 19.3892 27.8429 19.8752 27.7683 21.4883C27.7013 22.9808 27.4507 23.7902 27.2421 24.3298C26.995 24.9936 26.6035 25.5942 26.0959 26.0883C25.5602 26.6241 25.0512 26.9551 24.3355 27.2325C23.7998 27.443 22.9885 27.6918 21.494 27.7607C19.881 27.8334 19.3969 27.8506 15.3097 27.8506C11.2225 27.8506 10.7365 27.8334 9.12344 27.7607C7.63093 27.6918 6.82153 27.443 6.28193 27.2325C5.61764 26.9862 5.01636 26.5954 4.52154 26.0883C4.01308 25.5939 3.62092 24.9925 3.37345 24.3279C3.16488 23.7902 2.91422 22.9789 2.84725 21.4864C2.77454 19.8733 2.75923 19.3892 2.75923 15.3001C2.75923 11.211 2.77454 10.7308 2.84725 9.1177C2.91613 7.62519 3.16488 6.81388 3.37537 6.27428C3.65282 5.56055 3.98576 5.04965 4.52154 4.51388C5.05731 3.97811 5.56629 3.64708 6.28193 3.36963C6.82153 3.15914 7.63093 2.91039 9.12344 2.84151C10.5356 2.77645 11.0828 2.75731 13.9358 2.7554V2.75923ZM23.4802 5.30032C23.239 5.30032 23.0001 5.34783 22.7773 5.44015C22.5544 5.53246 22.3519 5.66777 22.1813 5.83835C22.0107 6.00892 21.8754 6.21142 21.7831 6.43429C21.6908 6.65716 21.6433 6.89602 21.6433 7.13725C21.6433 7.37848 21.6908 7.61735 21.7831 7.84022C21.8754 8.06308 22.0107 8.26559 22.1813 8.43616C22.3519 8.60674 22.5544 8.74204 22.7773 8.83436C23.0001 8.92667 23.239 8.97419 23.4802 8.97419C23.9674 8.97419 24.4346 8.78065 24.7791 8.43616C25.1236 8.09167 25.3172 7.62444 25.3172 7.13725C25.3172 6.65007 25.1236 6.18284 24.7791 5.83835C24.4346 5.49385 23.9674 5.30032 23.4802 5.30032ZM15.3097 7.44724C14.267 7.43097 13.2315 7.62229 12.2634 8.01007C11.2953 8.39784 10.4141 8.97432 9.67098 9.70594C8.92785 10.4376 8.3377 11.3097 7.93487 12.2716C7.53204 13.2335 7.32458 14.2659 7.32458 15.3087C7.32458 16.3516 7.53204 17.384 7.93487 18.3459C8.3377 19.3078 8.92785 20.1799 9.67098 20.9115C10.4141 21.6432 11.2953 22.2196 12.2634 22.6074C13.2315 22.9952 14.267 23.1865 15.3097 23.1702C17.3735 23.138 19.3418 22.2956 20.7898 20.8248C22.2379 19.354 23.0495 17.3727 23.0495 15.3087C23.0495 13.2447 22.2379 11.2635 20.7898 9.79268C19.3418 8.32186 17.3735 7.47943 15.3097 7.44724ZM15.3097 10.2046C15.9799 10.2046 16.6435 10.3365 17.2626 10.593C17.8818 10.8495 18.4443 11.2254 18.9182 11.6993C19.3921 12.1731 19.768 12.7357 20.0245 13.3549C20.2809 13.974 20.4129 14.6376 20.4129 15.3078C20.4129 15.9779 20.2809 16.6416 20.0245 17.2607C19.768 17.8799 19.3921 18.4424 18.9182 18.9163C18.4443 19.3902 17.8818 19.7661 17.2626 20.0226C16.6435 20.279 15.9799 20.411 15.3097 20.411C13.9562 20.411 12.6582 19.8734 11.7012 18.9163C10.7441 17.9593 10.2065 16.6612 10.2065 15.3078C10.2065 13.9543 10.7441 12.6563 11.7012 11.6993C12.6582 10.7422 13.9562 10.2046 15.3097 10.2046Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      href: "https://x.com/PlusWilla",
      icon: (
        <svg
          xmlns="https://www.w3.org/2000/svg"
          width={26}
          height={26}
          viewBox="0 0 24 24">
          <path
            fill="#fff"
            d="m17.687 3.063l-4.996 5.711l-4.32-5.711H2.112l7.477 9.776l-7.086 8.099h3.034l5.469-6.25l4.78 6.25h6.102l-7.794-10.304l6.625-7.571zm-1.064 16.06L5.654 4.782h1.803l10.846 14.34z"></path>
        </svg>
      ),
    },
    {
      href: "https://www.youtube.com/@PlusWilla",
      icon: (
        <svg
          xmlns="https://www.w3.org/2000/svg"
          width={28}
          height={28}
          viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="#fff"
            strokeLinejoin="round"
            strokeMiterlimit={10}
            strokeWidth={1.5}
            d="M22.54 6.42a2.77 2.77 0 0 0-1.945-1.957C18.88 4 12 4 12 4s-6.88 0-8.595.463A2.77 2.77 0 0 0 1.46 6.42C1 8.148 1 11.75 1 11.75s0 3.602.46 5.33a2.77 2.77 0 0 0 1.945 1.958C5.121 19.5 12 19.5 12 19.5s6.88 0 8.595-.462a2.77 2.77 0 0 0 1.945-1.958c.46-1.726.46-5.33.46-5.33s0-3.602-.46-5.33ZM9.75 15.021V8.48l5.75 3.271z"></path>
        </svg>
      ),
    },
  ];

  const handleScroll = (
    e: React.MouseEvent<HTMLAnchorElement>,
    target: string
  ) => {
    e.preventDefault();
    const element = document.querySelector(target);
    const offset = 100; // adjust if you have a sticky header
    if (element) {
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <>
      <footer className="w-[85%] mx-auto max-w-[110rem]">
        <div className="grid grid-cols-[100%] sm:grid-cols-[65%_35%] lg:grid-cols-[33%_20%_25%_22%] relative z-[2] ">
          <div className="w-[80%]">
            <div className="mb-[40px] md:mb-[60px]">
              <Image
                src={`${ASSET_PREFIX}/images/plus-willa-logo_final.svg`}
                alt="Plus Willa Logo"
                width={150}
                height={50}
                className="w-[110px] sm:w-[140px] h-auto invert-100"
                loading="lazy"
              />
              <p className="text-[#f0f0f1cc] font-[300] mt-[30px] text-[16px] leading-[24px]  sm:w-[80%]">
                +Willa, a visionary series of villas by Unitd Living Space that
                is a futuristic, sustainable, and stress-free upgrade for modern
                families, blending the best of nature and technology.
              </p>
            </div>
            <div className="mt-[15px] pl-[8px]">
              <ul className="flex gap-[25px] max-[1480px]:gap-[15px] items-center">
                {links.map(({ href, icon }, i) => (
                  <li key={i}>
                    <Link
                      href={href}
                      target="_blank"
                      className="text-[#444444] hover:text-[#1D3D76] transition-colors smicons"
                      aria-label="link">
                      {icon}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            {/* <div><p className="text-[#f0f0f1cc] mt-[20px] ml-[7px]"><Link href="#" target="_blank">Get Directions</Link></p></div> */}
          </div>
          {/* Quicl Links starts */}
          <div className="mt-[30px] sm:mt-[78px] md:mt-[113px]">
            <ul className="grid gap-[8px]">
              {/* About us */}
              <li className="text-[#f0f0f1cc] font-[300] hover:text-[#fff] transition duration-300 ease-in-out group">
                <Link href="/about">About us</Link>
                <div className="relative mt-[2px] mb-[5px] w-[70px]">
                  <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#b08d38] scale-x-0 origin-center transition-transform duration-500 group-hover:scale-x-100"></span>
                </div>
              </li>

              {/* Highlights */}
              <li className="text-[#f0f0f1cc] font-[300] hover:text-[#fff] transition duration-300 ease-in-out group">
                <Link href="/highlights">Highlights</Link>
                <div className="relative mt-[2px] mb-[5px] w-[75px]">
                  <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#b08d38] scale-x-0 origin-center transition-transform duration-500 group-hover:scale-x-100"></span>
                </div>
              </li>

              {/* Gallery */}
              <li className="text-[#f0f0f1cc] font-[300] hover:text-[#fff] transition duration-300 ease-in-out group">
                <Link href="/gallery">Gallery</Link>

                <div className="relative mt-[2px] mb-[5px] w-[55px]">
                  <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#b08d38] scale-x-0 origin-center transition-transform duration-500 group-hover:scale-x-100"></span>
                </div>
              </li>

              {/* Blogs */}
              <li className="text-[#f0f0f1cc] font-[300] hover:text-[#fff] transition duration-300 ease-in-out group">
                <Link href="/blog">Blogs</Link>

                <div className="relative mt-[2px] mb-[5px] w-[42px]">
                  <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#b08d38] scale-x-0 origin-center transition-transform duration-500 group-hover:scale-x-100"></span>
                </div>
              </li>

              {/* Contact us */}
              {/* <li className="text-[#f0f0f1cc] font-[300] hover:text-[#fff] transition duration-300 ease-in-out group">
                <Link href="/media">Media</Link>
                <div className="relative mt-[2px] mb-[5px] w-[83px]">
                  <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#b08d38] scale-x-0 origin-center transition-transform duration-500 group-hover:scale-x-100"></span>
                </div>
              </li> */}
              <li className="text-[#f0f0f1cc] font-[300] hover:text-[#fff] transition duration-300 ease-in-out group">
                <Link href="/contact-us" data-cta="contact-us-cta-footer">Contact us</Link>
                <div className="relative mt-[2px] mb-[5px] w-[83px]">
                  <span className="absolute left-0 bottom-0 w-full h-[2px] bg-[#b08d38] scale-x-0 origin-center transition-transform duration-500 group-hover:scale-x-100"></span>
                </div>
              </li>
            </ul>
          </div>
          {/* address starts */}
          <div className="mt-[30px] sm:mt-[113px]  relative z-[2]">
            <p className="text-[#f0f0f1cc] font-[300]">
              <b className="text-[18px] leading-[24px] font-[500] text-[#b08d38] mb-[8px]">
                Unitd Living Space
              </b>
              <br />
              <span className="text-nowrap">Grand CAG Central, </span>
              <br /> Coimbatore, <br />
              <span className="text-nowrap"> Tamil Nadu - 641 037.</span>
            </p>
          </div>
          {/* contact numbers */}
          <ul className="mt-[30px] sm:mt-[113px] relative z-[2]">
            <li className="text-[#AF8E43] text-[18px] leading-[26px] sm:text-[20px] sm:leading-[28px]  xl:text-[24px] xl:leading-[32px] font-[500] tracking-[-0.03em] mb-[2px] hover:text-[#fff] transition duration-300 ease-in-out">
              <Link
                href="tel:+917373737166"
                target="_blank"
                data-cta="call-cta-footer"
                className="call-cta">
                +91 73 73 73 71 66
              </Link>
            </li>
            <li className="text-[#f0f0f1cc] text-[18px] leading-[26px] sm:text-[20px] sm:leading-[28px]  xl:text-[24px] xl:leading-[32px] font-[400] hover:text-[#AF8E43] transition duration-300 ease-in-out">
              <Link
                href="mailto:enquiry@pluswilla.com"
                target="_blank"
                data-cta="email-cta-footer"
                className="enq-mail">
                enquiry@pluswilla.com
              </Link>
            </li>
          </ul>
        </div>

        <div className="border-t border-gray-700 max-[480px]:mb-[0] mt-[40px] sm:mt-[50px] md:mt-[80px] lg:mt-[100px] pt-[15px] sm:pt-[20px] ">
          <div className="flex flex-col md:flex-row justify-between gap-[0] sm:gap-[15px] max-md:gap-[5px] flex-wrap items-center">
            <p className="text-[#B7AF9D] text-[14px] leading-[24px] text-center md:text-left">
              © {new Date().getFullYear()} +Willa.{" "}
              <span className="text-nowrap">All rights reserved.</span> <Link href="/privacy-policy" className="underline hover:text-[#fff] transition duration-300 ease-in-out">Privacy Policy</Link>
            </p>
            <div className="grid sm:flex  justify-center text-center">
              <p className="text-[#B7AF9D] text-[14px] leading-[24px] transition-colors">
                Designed by <Link
                  href="https://www.signatures1.com/"
                  target="_blank"
                  className="text-[#B7AF9D] text-[14px] leading-[24px] hover:text-[#fff] transition-colors">
                  Signatures1
                </Link>
              </p>

              <div className="mx-[10px] text-[#B7AF9D] hidden sm:block">&</div>
              <p className="text-[#B7AF9D] text-[14px] leading-[24px] transition-colors">
                {" "}
                Developed by{" "}
                <Link
                  href="https://www.appacmedia.com/"
                  target="_blank"
                  className="text-[#B7AF9D] text-[14px] leading-[24px] hover:text-[#fff] transition-colors">
                  Appac Mediatech Pvt Ltd
                </Link>
              </p>
            </div>
          </div>
        </div>
      </footer>

      <div className="absolute bottom-[80px]">
        <Image
          src={`${ASSET_PREFIX}/images/icons/plus.webp`}
          alt="PlusWilla 25"
          width={351}
          height={357}
          className="w-[110px] sm:w-[130px] h-auto"
          loading="lazy"
        />
      </div>
      <div>
        {loadPopup ? <ContactPopup /> : null}

        <div
          className=" menq block !opacity-100
  fixed z-[996] h-0
  top-[45%] right-[-90px] -translate-y-1/2
  max-[480px]:top-auto max-[480px]:right-0 max-[480px]:bottom-0 max-[480px]:translate-y-0 max-[480px]:w-full transition-opacity duration-500 bottom-[0]">
          <ul
            className="
    flex flex-col items-center gap-[15px]
    max-[480px]:flex-row max-[480px]:gap-0 max-[480px]:w-full max-[480px]:bg-[#c71e36] max-[480px]:text-center  max-xsm:grid  max-xsm:grid-cols-1
  ">
            {/* Call Now */}
            <li
              className="
      list-none  h-[55px] px-[5px] ml-[-1px] cursor-pointer bg-[#fff]  hover:bg-[#fff] rounded-[50px_0_0_50px] shadow-md
      transition-all duration-300 ease-out transform translate-x-[5px] hover:translate-x-[-80px] pr-[20px]
      max-[480px]:rounded-none max-[480px]:h-auto max-[480px]:px-0 max-[480px]:py-[5px] max-[480px]:translate-x-0 max-[480px]:hover:translate-x-0 max-[480px]:flex-1 max-[480px]:bg-[#b08d39] max-[480px]:shadow-none  max-[480px]:border-r-2 max-[480px]:border-white clip-path-0  max-xsm:h-full  max-xsm:px-[10px] max-xsm:py-[15px]">
              <Link
                href="tel:+917373737166"
                data-cta="call-cta"
                className="call-cta flex items-center gap-[10px] max-xsm:gap-[15px] pt-[7px]
                   max-[480px]:flex-row max-[480px]:gap-1 max-[480px]:pt-0 max-[480px]:text-white  max-xsm:flex-row max-xsm:h-full justify-center max-xsm:justify-center">
                <span className="flex items-center justify-center w-[40px] h-[40px] max-[480px]:h-[30px] max-[480px]:w-[30px] rounded-[5px]  bg-[#fff] max-[480px]:bg-transparent rounded-[50px]">
                  <svg
                    xmlns="https://www.w3.org/2000/svg"
                    className="w-[30px] h-[30px] max-[480px]:text-[#fff] text-white pl-[5px]"
                    viewBox="0 0 24 24">
                    <g fill="none" stroke="none">
                      <g fill="#000">
                        <path
                          d="M4.024 9L4 8.931C3.46 7.384 3 5.27 3 4c0-.55.45-1 1-1h3a2
                         2 0 0 1 2 2v2a2 2 0 0 1-2 2h-.837A16.054 16.054 0 0 0 15
                         17.837V17a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v3c0 .45-.55 1-1
                         1c-1.725 0-3.44-.456-5-1c-5.114-1.832-9.168-5.886-10.976-11Z"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
                <span className="font-semibold max-[480px]:text-[14px] max-[480px]:text-[#000] max-[480px]:leading-[18px] ">
                  Call Now
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* <div className="fixed z-[999]   top-1/2 right-[0] -translate-y-1/2   max-[480px]:top-auto max-[480px]:left-0 max-[480px]:bottom-0 max-[480px]:translate-y-0 max-[480px]:w-full">
      <Image
                          src={`${ASSET_PREFIX}/images/icons/tw.svg`}
                          alt=""
                          width={100}
                          height={80}
                          className="w-[100px] h-[80px]  transition duration-300 ease-in-out"
                          unoptimized
                        />
     </div> */}
    </>
  );
}
